import { GET_PROFILE_SETUP } from "../configs/routes.js";
import api from "./api.js";

export function getProfileSetup() {
  return api.get(GET_PROFILE_SETUP).then((response) => response.data);
}

export default getProfileSetup;
